import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const ProductCard = ({ product }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ y: -5 }}
      className="group relative bg-white rounded-lg overflow-hidden transition-all duration-300 hover:shadow-xl border border-stone-100"
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/product/${product.id}`}>
        {/* Image Container */}
        <div className="relative aspect-[3/4] overflow-hidden bg-[#F5F1EB]">
          {product.image_url ? (
            <img
              src={product.image_url}
              alt={product.name}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center">
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#C5A059] to-[#E5C88A] opacity-30" />
            </div>
          )}
          
          {/* Featured Badge */}
          {product.featured && (
            <div className="absolute top-3 left-3 bg-[#5D6D53] text-white text-xs px-3 py-1 rounded-full font-medium">
              Featured
            </div>
          )}

          {/* Quick View Overlay */}
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center">
            <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white text-[#2C2C2C] px-6 py-2 rounded-full font-medium text-sm shadow-lg">
              View Details
            </span>
          </div>
        </div>

        {/* Product Info */}
        <div className="p-4">
          <p className="text-xs text-[#8C8C8C] uppercase tracking-wider mb-1">
            {product.category?.replace('-', ' ')}
          </p>
          <h3 className="font-serif text-lg text-[#2C2C2C] mb-2 group-hover:text-[#C5A059] transition-colors">
            {product.name}
          </h3>
          {product.scent && (
            <p className="text-sm text-[#595959] mb-2 line-clamp-1">{product.scent}</p>
          )}
          <p className="text-[#C5A059] font-semibold text-lg">
            £{product.price?.toFixed(2)}
          </p>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
